var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-icon',{staticClass:"info-icon",attrs:{"color":"black"}},[_vm._v(" mdi-information-outline ")])
}
var staticRenderFns = []

export { render, staticRenderFns }